module.exports = __webpack_public_path__ + "static/img/profile.473f597.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/profile.jpg
// module id = SQGw
// module chunks = 30